import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Navber.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Navbar() {
  const navigate = useNavigate();
  const { isAuthenticated ,token} = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);

  const scrollToSection = (id) => {
    setOpen(false);

    const section = document.getElementById(id);
    if (!section) return;

    // Scroll smooth
    window.scrollTo({
      top: section.offsetTop - window.innerHeight * 0.03, // 3% above the section
      behavior: "smooth",
    });

    // Animation class
    section.classList.add("section-animate");

    // Remove animation class after animation ends
    setTimeout(() => {
      section.classList.remove("section-animate");
    }, 600);
  };

  return (
    <motion.nav
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="navbar"
    >
      <div className="nav-container">

        <h2 className="logo" onClick={() => {scrollToSection("hero");navigate("/")}}>Dhanushdhari Renovators</h2>

        <div className={`nav-links ${open ? "open" : ""}`}>
          <a onClick={() => scrollToSection("hero")}>Home</a>
          <a onClick={() => scrollToSection("about")}>About</a>
          <a onClick={() => navigate("/services")}>Services</a>
          <a onClick={() => scrollToSection("projects")}>Projects</a>
          <a onClick={() => scrollToSection("contact")}>Contact</a>
        </div>
 <img src="/user.png" style={{margin:"0px 20px",width:"30px",backgroundColor:"white",borderRadius:"50%"}}
         onClick={()=>{ isAuthenticated?navigate("/profile"):navigate("/login")}}
        />
        <div className={`hamburger ${open ? "active" : ""}`} onClick={() => setOpen(!open)}>
          <span></span><span></span><span></span>
        </div>
        

      </div>
    </motion.nav>
  );
}
